var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},_vm._l((_vm.summaryCards),function(card,key){return _c('v-col',{key:key,attrs:{"xl":"","lg":"4","md":"4","sm":"12"}},[_c('ActivityCard',{class:key,staticStyle:{"height":"100%"},attrs:{"count":card.count,"label":card.label,"icon":card.icon,"iconColor":card.iconColor,"color":card.color}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }